import React, { Component } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';

import RTVReview from '../../../commons/RTVReview';
import { fetchReviews } from '../../../redux/actions/user';
import { ReactComponent as Logo } from '../../../images/hanger.svg';
import { USER_RECEIVED_REVIEWS_REQUESTED } from '../../../redux/actions/types';
import '../../../commons/loading/animation.scss';

const styles = theme => ({
  root: {
    padding: theme.spacing(1)
  },
  reviewsSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
  },
  review: {
    flex: 0,
    minWidth: '350px',
    width: '300px',
    padding: theme.spacing(4)
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
});

class Reviews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reviews: props.reviews[props.user.id] || [],
      pageCounter: 1,
      size: 10,
      disabledButton: false
    };
  }

  componentDidMount() {
    this.props.fetchReviews(this.props.user.id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !lodash.isEqual(prevProps.user, this.props.user) ||
      prevState.pageCounter !== this.state.pageCounter
    ) {
      this.props.fetchReviews(
        this.props.user.id,
        this.state.pageCounter,
        this.state.size
      );
    }
    if (!lodash.isEqual(prevProps.reviews, this.props.reviews)) {
      if (this.state.pageCounter > 1) {
        if (this.props.reviews[this.props.user.id] < 10) {
          this.setState({ disabledButton: true });
        }
        this.setState({
          reviews: prevState.reviews.concat(
            this.props.reviews[this.props.user.id]
          )
        });
      } else {
        this.setState({
          reviews: this.props.reviews[this.props.user.id] || []
        });
      }
    }
  }

  loadMore = () => {
    this.setState(state => ({
      pageCounter: state.pageCounter + 1
    }));
  };

  render() {
    const { classes } = this.props;

    if (!this.state.reviews.length) {
      return '';
    }

    return (
      <div className={classes.root}>
        <Typography style={{ fontSize: '1.2rem', fontWeight: 600 }}>
          Últimas calificaciones
        </Typography>
        <div className={classes.reviewsSection}>
          {this.state.reviews.map(review => (
            <RTVReview classes={{ root: classes.review }} review={review} />
          ))}
        </div>
        <div className={classes.buttonContainer}>
          {this.props.status === USER_RECEIVED_REVIEWS_REQUESTED ? (
            <Logo className="hanger-movement" width="100px" height="100px" />
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.loadMore()}
              disabled={this.state.disabledButton}
            >
              {this.state.disabledButton ? 'Llegaste al final!' : 'Ver más'}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  reviews: state.user.reviews,
  status: state.user.status
});

const mapDispatchToProps = dispatch => ({
  fetchReviews: (user, page, size) => dispatch(fetchReviews(user, page, size))
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Reviews)
);
